import DataEngineering from 'components/data-engineering/DataEngineering.jsx'
import clientPromise from "lib/mddb.mjs";
import computeFields from "lib/computeFields";
import fs from "fs";
import React from "react";

export default function DataEngineeringPage({blogs,casestudies}){
  return(
    <DataEngineering blogs={blogs} casestudies={casestudies}  />
  )
}

export async function getStaticProps() {
  const mddb = await clientPromise;

  const blogFiles = await mddb.getFiles({ folder: "blog" });
  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });
  
  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);
  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);

  return {
    props: {
      meta: {
        title: "Data Engineering",
        description: "Whether your data is big or small, we design and build robust systems and dataflows with your business goals in mind.",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
      },
      blogs: blogsList,
      casestudies: caseStudiesList,
    },
  };
};